'use client';

import { CartIcon, ListIcon } from '@ahamove/icons/subscription';
import { ScrollArea, Tabs, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';

import ProgressesSubscriptionList from './components/progresses/progresses-subscription-list';
import SubscriptionHistoryList from './components/subscription-history/subscription-history-list';
import SubscriptionList from './components/subscription-list';
import styles from './components/subscription-styles.module.css';

import HistoryIcon from '@/assets/icons/history-icon.svg';
import {
  SubscriptionTab,
  useSubscriptionsStore,
} from '@/features/booking/store';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

const SUBSCRIPTION_TABS = [
  SubscriptionTab.subscription,
  SubscriptionTab.my_subscriptions,
  SubscriptionTab.subscriptions_history,
];

const ICONS = {
  [SubscriptionTab.subscription]: ListIcon,
  [SubscriptionTab.my_subscriptions]: CartIcon,
  [SubscriptionTab.subscriptions_history]: HistoryIcon,
};

export default function SubscriptionContainer() {
  const isMobile = useIsMobile();
  const tSubscription = useTranslations('subscription');

  const activeTab = useSubscriptionsStore.use.activeTab();
  const setActiveTab = useSubscriptionsStore.use.setActiveTab();

  const visibleTabs = isMobile
    ? SUBSCRIPTION_TABS.filter(
        (tab) => tab !== SubscriptionTab.subscriptions_history
      )
    : SUBSCRIPTION_TABS;

  const renderIcon = (tab: SubscriptionTab) => {
    const Icon = ICONS[tab];
    const isActive = activeTab === tab;

    return (
      <Icon
        style={{
          fill: isActive
            ? 'var(--mantine-color-primary-6)'
            : 'var(--mantine-color-neutral-6)',
        }}
        width={24}
        height={24}
      />
    );
  };

  return (
    <Tabs
      flex={1}
      h="100%"
      w="100%"
      display="flex"
      value={activeTab}
      onChange={setActiveTab}
      variant="none"
      styles={{ root: { flexDirection: 'column' } }}
    >
      <Tabs.List
        py={isMobile ? rem(16) : rem(24)}
        justify="center"
        className={styles.list}
        style={{ zIndex: 2 }}
        mb={0}
      >
        {visibleTabs.map((tab) => (
          <Tabs.Tab
            key={tab}
            w={`${100 / visibleTabs.length}%`}
            leftSection={renderIcon(tab)}
            value={tab}
            className={styles.tab}
          >
            {tSubscription(tab)}
          </Tabs.Tab>
        ))}
      </Tabs.List>

      <ScrollArea
        pos="relative"
        h="100%"
        classNames={{ viewport: '[&>div]:!block' }}
      >
        <Tabs.Panel value={SubscriptionTab.subscription}>
          <SubscriptionList />
        </Tabs.Panel>

        <Tabs.Panel value={SubscriptionTab.my_subscriptions}>
          <ProgressesSubscriptionList />
        </Tabs.Panel>

        <Tabs.Panel value={SubscriptionTab.subscriptions_history}>
          <SubscriptionHistoryList />
        </Tabs.Panel>
      </ScrollArea>
    </Tabs>
  );
}
